import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { changed: Boolean }

  connect() {
    this.notifyNative(this.changedValue)
  }

  formIsChanged() {
    this.setChanged("true")
  }

  leavingPage(event) {
    if (this.changedValue) {
      if (event.type == "turbo:before-visit") {
        event.preventDefault()

        window.location = event.detail.url
      } else {
        event.returnValue = 1
        return event.returnValue
      }
    }
  }

  allowFormSubmission() {
    this.setChanged("false")
  }

  setChanged(changed) {
    this.changedValue = changed
    this.notifyNative(changed === true || changed === "true")
  }

  notifyNative(changed) {
    window.webkit?.messageHandlers?.unsavedChanges?.postMessage(changed)
    window.TestlyExamGuard?.report(changed)
  }
}
